module.exports = __webpack_public_path__ + "img/joel-headshot2.3b73fcfd.png";